import { Link } from "react-router-dom";

function Header({ bigWindow }) {
  return (
    <div className="header-wrapper">
      <div className="projects-button">
        <Link to={"/projects"}>My Projects</Link> | <Link to={"/writing"}>My Writing</Link>
      </div>
      <h1>Hi, my name is<br />Ben Bucaj</h1>
      {bigWindow ? (
        <>
          <p>I graduated from Boston University with a Bachelor's degree in Computer Science and Political Science, along with a minor in History.</p>
          <p><br />I like to think I’m a hard worker and well organized. In just 2.5 years (Jan 2023 - Aug 2025), I completed my Computer Science major and earned 140 credits despite only 128 being required to graduate, always pushing myself to learn more.</p>
          <p><br />Along the way, I studied in four cities, Boston, London, Sydney, and Dublin, while completing international product internships that broadened both my technical and global perspective.</p>
          <p><br />But that's not all! Take a look through my pics on the right to learn a bit about me.</p>
        </>
      ) : (
        <>
          <p>
            I graduated from Boston University with a Bachelor's degree in Computer Science and Political Science, along with a minor in History. Browse through the photos below to learn a bit more about me.
          </p>
        </>
      )}
    </div>
  );
}

export default Header;